const guids: Record<string, number> = {};

export function guid(prefix: string): string {
  const index = guids[prefix] ?? 0;
  const current = index + 1;

  guids[prefix] = current;

  return `${prefix}-${current}`;
}
